import { createFileRoute } from "@tanstack/react-router";
import { QuestionMaker } from "#/components/QuestionMaker";

export const Route = createFileRoute("/")({ component: Home });

function Home() {
	return <QuestionMaker />;
}
